import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-heat-map',
    templateUrl: './heat-map.component.html',
    styleUrls: ['./heat-map.component.css']
})

export class HeatMapComponent implements OnInit {

    public weeks: number[] = Array.from({ length: 52 }, (_, i) => i + 1);
    public months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    public constructor() { }

    public ngOnInit(): void { }

    public getDayActivityClassName = (dow: number, week: number): string => {

        let result = "heatmap-tile";
        const doy: number = (week * 7) + dow;
        let random: number = Math.random();

        const now: any = new Date();
        const currentDayOfWeek: number = now.getDay();
        const currentWeekOfYear: number = this.getWeekNumber(now);

        if (week < currentWeekOfYear || (week == currentWeekOfYear && dow <= currentDayOfWeek)) {

            if (week < 3) {

                if (random > 0.9) {

                    result = result + " activity-lowest";

                } else {

                    result = result + " activity-none";
                }

            } else if (week > 10 && week <= 14) {

                if (random > 0.8) {

                    result = result + " activity-lowest";

                } else if (random >= 0.8 && random < 0.95) {

                    result = result + " activity-medium-low";

                } else {

                    result = result + " activity-none";
                }

            } else if (dow == 7) {

                if (random > 0.9) {

                    result = result + " activity-lowest";

                } else {

                    result = result + " activity-none";
                }

            } else if (dow == 6) {

                if (random > 0.8) {

                    result = result + " activity-lowest";

                } else if (random >= 0.8 && random < 0.95) {

                    result = result + " activity-medium-low";

                } else {

                    result = result + " activity-none";
                }

            } else {

                if (random < 0.2) {

                    result = result + " activity-lowest";

                } else if (random >= 0.2 && random < 0.4) {

                    result = result + " activity-medium-low";

                } else if (random >= 0.4 && random < 0.6) {

                    result = result + " activity-medium-high";

                } else if (random >= 0.6 && random < 0.8) {

                    result = result + " activity-highest";

                } else {

                    result = result + " activity-none";
                }
            }

        } else {

            result = result + " activity-none";
        }

        return result;
    }

    private getWeekNumber = (date: Date): number => {

        const tempDate: any = new Date(date.valueOf());
        const dayNum = (date.getDay() + 6) % 7;                                 // iso week dates start on Monday (0 for Monday, 1 for Tuesday, and so on)

        tempDate.setDate(date.getDate() + 4 - dayNum);                          // set the target to the nearest thursday (current date + 4 - current day number)

        const firstWeekOfYear: any = new Date(tempDate.getFullYear(), 0, 4);    // January 4 is always in week 1

        return Math.ceil((tempDate - firstWeekOfYear + 1) / (7 * 24 * 60 * 60 * 1000)); // adjust to thursday in week 1 and count the number of weeks from date to week1
    }
}
